import React from 'react';
import './Service.css';

import { renderIcon } from '../../utils';  // Utility function to render service icon

import { Link } from 'react-router-dom';  // Link component to navigate to different pages
import { FaArrowRight } from 'react-icons/fa';



const Service = ({service}) => {

  // Destructuring props to extract the necessary details for each service
  const { id, image, title, content } = service;

  return (

    <div className='service-item' key={id}>

      <img src={image} alt={title} />{/* Service Image */}

      <div className='content'>

        <div className='icon'>{renderIcon(title)}</div> {/* Display the service icon based on title */}

        {/* Link to the individual service page */}
        <Link
          to={{ 
            pathname: '/Services/' + title,  // Navigate to the specific service page
          }}
          location = {{service}}  // Passing service details to the linked page
          state= {service}> 
          <h3>{title}</h3> {/* Service Title */}
        </Link>

        <span></span>

        <p>{content}</p> {/* Service Description */}

        {/* Read more link to navigate to the full service page */}
        <Link
          to={{ 
            pathname: '/Services/' + title,  // Navigate to the specific service page
          }}
          location = {{service}}  // Passing service details to the linked page
          className='arrow-btn'  // Apply button style
          state= {service}><FaArrowRight />
        </Link>  {/* Button to read more about the service */}

      </div>

    </div>

  );
};

export default Service;